export default "__VITE_ASSET__DkAEzr5h__"